const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import GameUtil from "../../../../utility/game_util";
import SpriteFrameHolder from "../../ui/spriteFrameHolder";
import DialogReceiveItem from "./dialog_receive_item";
import PrefabsHolder from "../../component/prefabsHolder";

@ccclass
export default class DialogReceiveView extends ViewBase {

    @property(SpriteFrameHolder)
    iconSpriteHolder: SpriteFrameHolder = null

    @property(DialogReceiveItem)
    itemPrefab: DialogReceiveItem = null

    @property(dragonBones.ArmatureDisplay)
    bgDragonBones: dragonBones.ArmatureDisplay = null

    @property(cc.Prefab)
    avatarFramePrefab: cc.Prefab = null

    @property(cc.Animation)
    bgAnim: cc.Animation = null

    @property(cc.Node)
    nodeGoUseBtn: cc.Node = null

    get avatarFramePrefabsHolder(){
        if(!this.m_avatarFramePrefabsHolder){
            let node = cc.instantiate(this.avatarFramePrefab)
            node.active = false
            node.parent = this.node
            this.m_avatarFramePrefabsHolder = node.getComponent(PrefabsHolder)
        }
        return this.m_avatarFramePrefabsHolder
    }

    protected m_itemList: DialogReceiveItem[] = []

    protected m_avatarFramePrefabsHolder: PrefabsHolder = null

    showPanel(dataList: {type: number, num: number, itemCode?: string}[]){
        for (let index = 0; index < this.m_itemList.length; index++) {
            const item = this.m_itemList[index];
            item.node.active = false
        }
        let hasRecorder = false
        for (let index = 0; index < dataList.length; index++) {
            const data = dataList[index];
            let item = this.m_itemList[index]
            if(!item){
                let node = cc.instantiate(this.itemPrefab.node)
                node.parent = this.itemPrefab.node.parent                
                item = this.m_itemList[index] = node.getComponent(DialogReceiveItem)
            }
            item.reset()
            item.node.active = true
            let spriteFrameKey = ''
            let spriteFrameHolder: SpriteFrameHolder = null
            let scale = 1
            switch (data.type) {
                case 5:
                    spriteFrameKey = 'chip'
                    spriteFrameHolder = this.iconSpriteHolder
                    break;
                case 6:
                    spriteFrameKey = 'gold'
                    spriteFrameHolder = this.iconSpriteHolder
                    break
                case 10:
                    spriteFrameKey = data.itemCode
                    if(this.isAvatarFrame(data.itemCode)){
                        scale = 0.62                        
                    }else if(this.isPokerBack(data.itemCode)){
                        scale = 0.56
                        spriteFrameHolder = this.iconSpriteHolder
                    }else{                        
                        if(data.itemCode == 'JPQ_ITEM'){
                            hasRecorder = true
                        }
                        spriteFrameHolder = this.iconSpriteHolder
                    }
                    
                    break
                case 100:
                    spriteFrameKey = 'daibi'
                    spriteFrameHolder = this.iconSpriteHolder
                    break
                default:
                    break;
            }
            if(spriteFrameHolder){
                item.setData(spriteFrameHolder.getSpriteFrameByKey(spriteFrameKey), data.num, scale)
            }else{
                let prefab = this.avatarFramePrefabsHolder.getNodeByKey(spriteFrameKey)
                console.log('------------', spriteFrameKey, prefab)
                if(prefab){
                    let node = cc.instantiate(prefab)
                    item.setDragonBones(node, data.num, scale)
                }                
            }
            
        }
        this.nodeGoUseBtn.active = !!hasRecorder
        this.playBgAnim(true)
    }


    playBgAnim(show: boolean, onFinish?: Function){
        this.cancelAllSchedule()
        let animName = show? 'Play1': 'End'
        let clipName = show? 'anim_public_yuan': 'anim_public_yuan1'
        let delay = show? 2.8: 0.2
        this.bgDragonBones.playAnimation(animName, 1)
        this.bgAnim.play(clipName)
        if(onFinish){
            this.doScheduleOnce(onFinish, delay)
        }
    }

    isAvatarFrame(itemCode: string){
        let prefabList = this.avatarFramePrefabsHolder.prefabList
        for (let index = 0; index < prefabList.length; index++) {
            const element = prefabList[index];
            if(itemCode == element.key){
                return true
            }
        }
        return false
    }

    isPokerBack(itemCode: string){
        return itemCode.startsWith('Card_Icon_')
    }
}